export const FIT_TO_SCREEN_PAGE_CLASS =
  'flex flex-col gap-page-gap lg:h-[calc(100dvh_-_var(--spacing-app-header)_-_var(--spacing-app-gutter-top)_-_var(--spacing-app-gutter-y))]';
